import { Tabs, TabPanels, TabPanel, Box } from '@chakra-ui/react'

import { OfferHeaderExtra } from './OfferHeaderExtra'
import { BasicInfoExtraTab } from './tabs/carkulka-extra'
import { offerStatusColors } from '../../data/offers/utils/offerStatusColors'
import { useMemo, useRef, useState } from 'react'
import { AnimatedOfferWrapper, animationVariants } from './AnimatedOfferWrapper'
import { OfferAddon } from 'BrokerTsLib/src/dtos'
import { offerStatusEnum } from 'BrokerTsLib/src/enums/offerStatusEnum'

export interface OfferProps {
  offers: OfferAddon[]
}

const OfferFooter = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box sx={{ bgColor: 'gray.100', borderBottomRadius: 'md' }} as="footer">
      {children}
    </Box>
  )
}

export const OfferExtraCar = ({ offers }: OfferProps) => {
  const offerRef = useRef(null)

  const activeOffer = offers.find((x) => x.isActive)
  const hasError = (activeOffer?.errors?.length ?? 0) > 0
  const status = useMemo(() => {
    let status = offerStatusEnum.Valid
    if (hasError) status = offerStatusEnum.Error
    // else status = offerStatusEnum.Selected
    return status
  }, [hasError, activeOffer?.offerId])

  const color = offerStatusColors[status]

  if (!activeOffer) return <></>

  return (
    <AnimatedOfferWrapper
      ref={offerRef}
      transition={{ duration: 0.3 }}
      variants={animationVariants}
    >
      <OfferHeaderExtra offer={activeOffer} status={status} color={color} />

      <OfferFooter>
        <Tabs
          variant="default"
          colorScheme="primary"
          sx={{ borderBottomEndRadius: 'md', borderBottomStartRadius: 'md', overflow: 'hidden' }}
        >
          <TabPanels>
            <TabPanel>
              <BasicInfoExtraTab offers={offers} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </OfferFooter>
    </AnimatedOfferWrapper>
  )
}
